import React, { useState } from "react";
import ReactDOM from "react-dom";
import "./App.css";
import { chosenTheme } from "./theme";
import { GlobalStyles } from "./global";
import { ThemeProvider } from "styled-components";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// import Navbar from "./components/Navbar/Navbar";
import NavMobile from "./components/Navbar/NavMobile";
import NavbarHome from "./components/NavbarHome/NavbarHome";
import MainHeading from "./components/MainHeading/MainHeading";
import MainHeading1 from "./components/MainHeading1/MainHeading1";
import Bubble from "./components/BubbleChart/BubbleChart";
import SliderFile from "./components/SliderFile/SliderFile";
import Title from "./components/Title1/Title";
import Title1 from "./components/Title/Title";
import Quiz from "./components/Quiz/Quiz";
import Main from "./containers/Main";
import "./App.css";
import Card from "./components/Card/Card";
import Instruction from "./components/Instruction/Instruction";
import QuizComponent from "./components/QuizComponent/QuizComponent";

import QuizInstruction from "./components/QuizInstruction/QuizInstruction";
import QuizAnswer from "./components/QuizAnswer/QuizAnswer";

function App(props) {
  const [ans1, setAns1] = useState(2);
  const [ans2, setAns2] = useState(2);
  const [ans3, setAns3] = useState(2);
  const [ans4, setAns4] = useState(2);
  const [ans5, setAns5] = useState(2);
  const [ans6, setAns6] = useState(2);
  const [ans7, setAns7] = useState(2);
  const [ans8, setAns8] = useState(2);
  const [ans9, setAns9] = useState(2);
  const [ans10, setAns10] = useState(2);
  const [ans11, setAns11] = useState(2);
  const [ans12, setAns12] = useState(2);
  const [ans13, setAns13] = useState(2);

  const [mcq1, setmcq1] = useState(null);
  const [mcq2, setmcq2] = useState(null);
  const [mcq3, setmcq3] = useState(null);
  const [mcq4, setmcq4] = useState(null);
  const [mcq5, setmcq5] = useState(null);
  const [mcq6, setmcq6] = useState(null);
  const [mcq7, setmcq7] = useState(null);
  const [mcq8, setmcq8] = useState(null);
  const [mcq9, setmcq9] = useState(null);
  const [mcq10, setmcq10] = useState(null);
  const [mcq11, setmcq11] = useState(null);

  const [quizvalue, setQuizvalue] = useState(0);
  const buttonClicked = (
    q1,
    q2,
    q3,
    q4,
    q5,
    q6,
    q7,
    q8,
    q9,
    q10,
    q11,
    q12,
    q13
  ) => {
    setAns1(q1);
    setAns2(q2);
    setAns3(q3);
    setAns4(q4);
    setAns5(q5);
    setAns6(q6);
    setAns7(q7);
    setAns8(q8);
    setAns9(q9);
    setAns10(q10);
    setAns11(q11);
    setAns12(q12);
    setAns13(q13);
    setToggle(!toggle);
  };
  const quizsubmitClicked = (
    value1,
    value2,
    value3,
    value4,
    value5,
    value6,
    value7,
    value8,
    value9,
    value10,
    value11
  ) => {
    let total = 0;
    if (value1 == 0) {
      total += 150;
    } else if (value1 == 1) {
      total += 100;
    } else if (value1 == 2) {
      total += 50;
    } else if (value1 == 3) {
      total += 25;
    } else if (value1 == 4) {
      total += 0;
    }

    if (value2 == 0) {
      total += 100;
    } else if (value2 == 1) {
      total += 90;
    } else if (value2 == 2) {
      total += 50;
    } else if (value2 == 3) {
      total += 25;
    } else if (value2 == 4) {
      total += 0;
    }
    if (value3 == 0) {
      total += 20;
    } else if (value3 == 1) {
      total += 40;
    } else if (value3 == 2) {
      total += 60;
    } else if (value3 == 3) {
      total += 80;
    } else if (value3 == 4) {
      total += 100;
    }
    if (value4 == 0) {
      total += 50;
    } else if (value4 == 1) {
      total += 100;
    } else if (value4 == 2) {
      total += 25;
    } else if (value4 == 3) {
      total += 0;
    }
    if (value5 == 0) {
      total += 10;
    } else if (value5 == 1) {
      total += 50;
    } else if (value5 == 2) {
      total += 75;
    } else if (value5 == 3) {
      total += 100;
    } else if (value5 == 4) {
      total += 25;
    }
    if (value6.checkedA) {
      total += 20;
    }
    if (value6.checkedB) {
      total += 20;
    }
    if (value6.checkedC) {
      total += 20;
    }
    if (value6.checkedD) {
      total += 20;
    }
    if (value6.checkedE) {
      total += 20;
    }
    if (value7.checkedA) {
      total += 25;
    }
    if (value7.checkedB) {
      total += 25;
    }
    if (value7.checkedC) {
      total += 25;
    }
    if (value7.checkedD) {
      total += 25;
    }
    if (value7.checkedE) {
      total += 25;
    }
    if (value8.checkedA) {
      total += 25;
    }
    if (value8.checkedB) {
      total += 25;
    }
    if (value8.checkedC) {
      total += 25;
    }
    if (value8.checkedD) {
      total += 25;
    }
    if (value9.checkedA) {
      total += 25;
    }
    if (value9.checkedB) {
      total += 25;
    }
    if (value9.checkedC) {
      total += 25;
    }
    if (value9.checkedD) {
      total += 25;
    }
    if (value10.checkedA) {
      total += 20;
    }
    if (value10.checkedB) {
      total += 20;
    }
    if (value10.checkedC) {
      total += 20;
    }
    if (value10.checkedD) {
      total += 20;
    }
    if (value11 == 0) {
      total += 10;
    } else if (value11 == 1) {
      total += 20;
    } else if (value11 == 2) {
      total += 50;
    } else if (value11 == 3) {
      total += 100;
    }
    console.log(total);
    setQuizvalue(total);
    setmcq1(value1);
    setmcq2(value2);
    setmcq3(value3);
    setmcq4(value4);
    setmcq5(value5);
    setmcq6(value6);
    setmcq7(value7);
    setmcq8(value8);
    setmcq9(value9);
    setmcq10(value10);
    setmcq11(value11);
    setmultiplequiztotal(false);
  };
  const [toggle, setToggle] = useState(true);
  const [toggleIns, setToggleIns] = useState(true);
  const nextClicked = () => {
    setToggleIns(false);
  };
  const [multiplequiztotal, setmultiplequiztotal] = useState(true);
  const [quiztoggle, setquiztoggle] = useState(true);
  const quiznextClicked = () => {
    setquiztoggle(false);
  };
  return (
    <Router>
      <div>
        <Switch>
          <Route path="/" exact>
            <NavbarHome />
            <MainHeading1 heading2="Resources" />
            <Card />
          </Route>
          <Route path="/okrs" exact>
            <NavMobile />
            <MainHeading heading="OKR" heading2="CheatSheet" />
            <Title />
            <Bubble />
          </Route>
          <Route path="/cheatsheet/:pathid/:subid" exact>
            <NavMobile />
            <MainHeading heading="OKR" heading2="CheatSheet" />

            <Title />
            <SliderFile />
          </Route>
          <Route path="/cheatsheet/:pathid" exact>
            <NavMobile />
            <MainHeading heading="OKR" heading2="CheatSheet" />
            <Title />
            <Bubble />
          </Route>
          <Route path="/quiz" exact>
            <NavMobile />

            {multiplequiztotal && (
              <>
                {quiztoggle && (
                  <>
                    <QuizInstruction quiznextClicked={quiznextClicked} />
                  </>
                )}
                {!quiztoggle && (
                  <QuizComponent quizsubmitClicked={quizsubmitClicked} />
                )}
              </>
            )}
            {!multiplequiztotal && (
              <QuizAnswer
                quizvalue={quizvalue}
                mcq1={mcq1}
                mcq2={mcq2}
                mcq3={mcq3}
                mcq4={mcq4}
                mcq5={mcq5}
                mcq6={mcq6}
                mcq7={mcq7}
                mcq8={mcq8}
                mcq9={mcq9}
                mcq10={mcq10}
                mcq11={mcq11}
              />
            )}
          </Route>
          <Route path="/core-value-creator" exact>
            <div className="main_class">
              <NavMobile style={{ position: "absolute" }} />
              {toggle && (
                <div>
                  {toggleIns && (
                    <>
                      <MainHeading1 heading="Core Value Creator" />
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <Instruction nextClicked={nextClicked} />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                          marginTop: "30px",
                        }}
                      ></div>
                    </>
                  )}
                  {!toggleIns && (
                    <>
                      <Title1 />
                      <Quiz buttonClicked={buttonClicked} />
                    </>
                  )}
                </div>
              )}
              {!toggle && (
                <ThemeProvider theme={chosenTheme}>
                  <>
                    <GlobalStyles />
                    <Main
                      theme={chosenTheme}
                      ans1={ans1}
                      ans2={ans2}
                      ans3={ans3}
                      ans4={ans4}
                      ans5={ans5}
                      ans6={ans6}
                      ans7={ans7}
                      ans8={ans8}
                      ans9={ans9}
                      ans10={ans10}
                      ans11={ans11}
                      ans12={ans12}
                      ans13={ans13}
                    />
                  </>
                </ThemeProvider>
              )}
            </div>
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
